import React from 'react'
import loadable from '../utils/loadable'

// const Home = loadable(()=>import('../pages/home'))
const NavigationBar = loadable(() => import('../pages/navigationBar'))
const BasicManagement = loadable(() => import('../pages/BasicManagement'))
const MassivePoint = loadable(() => import('../pages/MassivePoint'))
const Statistics1 = loadable(() => import('../pages/statistics1'))
const Statistics2 = loadable(() => import('../pages/statistics2'))
const FeedbackSet = loadable(() => import('../pages/feedbackSet'))
const Comment = loadable(() => import('../pages/comment'))
const FeedbackList = loadable(() => import('../pages/feedbackList'))
const ContentManagement = loadable(() => import('../pages/contentManagement'))
const error500 = loadable(() => import('../pages/Result/500'))
const error404 = loadable(() => import('../pages/Result/404'))
const error = loadable(() => import('../pages/Result/error'))
const Shuffling = loadable(() => import('../pages/setup/shuffling'))
const Heritage = loadable(() => import('../pages/heritage'))
const Divison = loadable(() => import('../pages/heritage/division'))
const Culture = loadable(() => import('../pages/heritage/culture'))
const SetPawd = loadable(() => import('../pages/setPassword'))
const MiniappQr = loadable(() => import('../pages/miniappQr'))

const Village = loadable(() => import('../pages/village'))
const Township = loadable(() => import('../pages/village/township'))
const AddressType = loadable(() => import('../pages/village/addressType'))
const VillageCulture = loadable(() => import('../pages/village/culture'))
const Maintain = loadable(() => import('../pages/maintain'))
const Street = loadable(() => import('../pages/street'))
const RoadSigns = loadable(() => import('../pages/roadSigns'))
const routerList = [
  // {
  //     name:'首页',
  //     path:'/',
  //     ecact:true,
  //     component:Home
  // },
  // 地名管理 - 开始
  {
    name: '门牌管理',
    path: '/BasicManagement/1',
    ecact: true,
    component: BasicManagement
  },
  {
    name: '村牌管理',
    path: '/BasicManagement/3',
    ecact: true,
    component: BasicManagement
  },
  {
    name: '景区管理',
    path: '/BasicManagement/4',
    ecact: true,
    component: BasicManagement
  },
  {
    name: '道路管理',
    path: '/BasicManagement/5',
    ecact: true,
    component: BasicManagement
  },
  // 地名管理 - 结束
  // 数据统计 - 开始
  {
    name: '海量点',
    path: '/MassivePoint',
    ecact: true,
    component: MassivePoint
  },
  {
    name: '门牌统计',
    path: '/Statistics1/1',
    ecact: true,
    component: Statistics1
  },
  {
    name: '路牌统计',
    path: '/Statistics1/2',
    ecact: true,
    component: Statistics1
  },
  {
    name: '村牌统计',
    path: '/Statistics2/1',
    ecact: true,
    component: Statistics2
  },
  {
    name: '景区统计',
    path: '/Statistics2/2',
    ecact: true,
    component: Statistics2
  },
  // 数据统计 - 结束

  // 反馈管理 - 开始
  {
    name: '反馈列表',
    path: '/FeedbackList',
    ecact: true,
    component: FeedbackList
  },
  {
    name: '评论列表',
    path: '/comment',
    ecact: true,
    component: Comment
  },
  // 反馈管理 - 结束

  // 信息管理 - 开始
  {
    name: '瑞安概况',
    path: '/ContentManagement/1',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '行政区划',
    path: '/ContentManagement/2',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '地名咨询',
    path: '/ContentManagement/3',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '地名展览',
    path: '/ContentManagement/4',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '影像地名',
    path: '/ContentManagement/5',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '地名研究',
    path: '/ContentManagement/6',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '红色地名',
    path: '/ContentManagement/7',
    ecact: true,
    component: ContentManagement
  },
  // {
  //     name:'地名遗产',
  //     path:'/ContentManagement/8',
  //     ecact:true,
  //     component:ContentManagement
  // },
  {
    name: '地名文化',
    path: '/ContentManagement/9',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '北麓岛',
    path: '/ContentManagement/10',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '攻略',
    path: '/ContentManagement/11',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '公园路历史街区',
    path: '/ContentManagement/12',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '圣井山',
    path: '/ContentManagement/13',
    ecact: true,
    component: ContentManagement
  },
  {
    name: '东源村',
    path: '/ContentManagement/14',
    ecact: true,
    component: ContentManagement
  },
  // 信息管理 - 结束

  // 结果页 - 开始
  {
    name: '500',
    path: '/500',
    ecact: true,
    component: error500
  },
  {
    name: '404',
    path: '/404',
    ecact: true,
    component: error404
  },
  {
    name: 'error',
    path: '/error',
    ecact: true,
    component: error
  },
  // 小程序设置
  {
    name: 'shuffling',
    path: '/shuffling',
    ecact: true,
    component: Shuffling
  },
  // 地名遗产
  {
    name: 'heritage',
    path: '/heritage',
    ecact: true,
    component: Heritage
  },
  {
    name: 'culture',
    path: '/culture',
    ecact: true,
    component: Culture
  },
  {
    name: 'divison',
    path: '/divison',
    ecact: true,
    component: Divison
  },
  {
    name: 'SetPawd',
    path: '/setPassword',
    ecact: true,
    component: SetPawd
  },
  {
    name: 'MiniappQr',
    path: '/MiniappQr',
    ecact: true,
    component: MiniappQr
  },
  // 乡村地名
  {
    name: 'village',
    path: '/village',
    ecact: true,
    component: Village
  },
  {
    name: 'township',
    path: '/township',
    ecact: true,
    component: Township
  },
  {
    name: 'address_type',
    path: '/address_type',
    ecact: true,
    component: AddressType
  },
  {
    name: 'villageCulture',
    path: '/villageCulture',
    ecact: true,
    component: VillageCulture
  },
  // 维护管理
  {
    name: '维护记录',
    path: '/Maintain',
    ecact: true,
    component: Maintain
  },
  // 街巷管理
  {
    name: '街巷地名',
    path: '/Street',
    ecact: true,
    component: Street
  },
  {
    name: '路牌管理',
    path: '/RoadSigns',
    ecact: true,
    component: RoadSigns
  },
]

export default routerList